import { RSAA } from 'redux-api-middleware'
import { getApiPath } from 'sidecar-utility-library'

import { initialState, types } from './types'
import { getTzAdjustedStartDate } from 'utils/policies'

export const reapplyMember = applicant => ({
  [RSAA]: {
    endpoint: getApiPath(`acct`, `members/${applicant.uuid}/reapply`),
    method: 'POST',
    body: () => {
      if (applicant.quote) {
        applicant.quote = {
          ...applicant.quote,
          startDate: getTzAdjustedStartDate(applicant.quote),
        }
      }
      return JSON.stringify(applicant)
    },
    types: [
      types.REAPPLY_MEMBER_REQUEST,
      types.REAPPLY_MEMBER_SUCCESS,
      types.REAPPLY_MEMBER_ERROR,
    ],
  },
})

export default (
  state = initialState,
  { type, payload = {}, meta = {} } = {},
) => {
  switch (type) {
    case types.REAPPLY_MEMBER_REQUEST:
    case types.UPDATE_MEMBER_POLICY_REQUEST: {
      return {
        ...state,
        members: {
          ...state.members,
          busy: true,
          error: '',
        },
      }
    }

    // ----------

    case types.REAPPLY_MEMBER_ERROR:
    case types.UPDATE_MEMBER_POLICY_ERROR: {
      return {
        ...state,
        members: {
          ...state.members,
          busy: false,
          error: payload.response.message,
        },
      }
    }

    // ----------

    case types.REAPPLY_MEMBER_SUCCESS: {
      // we want to take out the returned upcoming policy
      // it'll get overridden anyway but just in case, don't want
      // any confusion as to which is the member's current policy
      const { ...memberObj } = payload

      const newMembers = {
        ...state.members.entities,
        [payload.uuid]: memberObj,
      }

      return {
        ...state,
        members: {
          ...state.members,
          busy: false,
          entities: newMembers,
        },
      }
    }

    // ----------

    case types.UPDATE_MEMBER_POLICY_SUCCESS: {
      const { uuid } = meta
      const newMembers = {
        ...state.members.entities,
        [uuid]: {
          ...state.members.entities[uuid],
          ...payload,
        },
      }
      return {
        ...state,
        members: {
          ...state.members,
          busy: false,
          entities: newMembers,
        },
      }
    }

    // ----------

    default:
      return state
  }
}
